import { createFileRoute, redirect } from '@tanstack/react-router';

import { parseHttpError } from '@repo/utils/parse-http-error';

import { queryCurrentUser, queryProjectById } from '~/services/authorization/authorization.ts';
import { NotFoundError } from '~/services/http.ts';

export const Route = createFileRoute('/project/$project')({
  beforeLoad: async ({ context: { queryClient }, params: { project } }) => {
    try {
      await queryClient.ensureQueryData(queryProjectById(project));
    }
    catch (error) {
      const status = parseHttpError(error).status;
      const hasNoProjectAccess = error instanceof NotFoundError || status === 401 || status === 403 || status === 404;

      if (hasNoProjectAccess) {
        const user = await queryClient.ensureQueryData(queryCurrentUser());

        throw redirect({ to: '/organization/$org', params: { org: user.organizationId }, replace: true });
      }

      throw error;
    }
  },
});
